import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AiAgentsAPI from '../../api/aiAgents';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isPublishing: false,
    isArchiving: false,
  },
};

export const getters = {
  getAgents(_state) {
    return _state.records;
  },
  getAgent: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isFetching: true });
    try {
      const response = await AiAgentsAPI.get();
      commit(types.SET_AI_AGENTS, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, id) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await AiAgentsAPI.show(id);
      commit(types.ADD_AI_AGENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isFetchingItem: false });
    }
  },

  create: async ({ commit }, data) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isCreating: true });
    try {
      const response = await AiAgentsAPI.create({ ai_agent: data });
      commit(types.ADD_AI_AGENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, data }) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isUpdating: true });
    try {
      const response = await AiAgentsAPI.update(id, { ai_agent: data });
      commit(types.EDIT_AI_AGENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isDeleting: true });
    try {
      await AiAgentsAPI.delete(id);
      commit(types.DELETE_AI_AGENT, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isDeleting: false });
    }
  },

  publish: async ({ commit }, id) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isPublishing: true });
    try {
      const response = await AiAgentsAPI.publish(id);
      commit(types.EDIT_AI_AGENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isPublishing: false });
    }
  },

  archive: async ({ commit }, id) => {
    commit(types.SET_AI_AGENT_UI_FLAG, { isArchiving: true });
    try {
      const response = await AiAgentsAPI.archive(id);
      commit(types.EDIT_AI_AGENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_UI_FLAG, { isArchiving: false });
    }
  },
};

export const mutations = {
  [types.SET_AI_AGENT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_AI_AGENTS]: MutationHelpers.set,
  [types.ADD_AI_AGENT]: MutationHelpers.setSingleRecord,
  [types.EDIT_AI_AGENT]: MutationHelpers.update,
  [types.DELETE_AI_AGENT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
